import { render, staticRenderFns } from "./PageInvite.vue?vue&type=template&id=5b0f8656"
import script from "./PageInvite.vue?vue&type=script&lang=js"
export * from "./PageInvite.vue?vue&type=script&lang=js"
import style0 from "./PageInvite.vue?vue&type=style&index=0&id=5b0f8656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports